import { render, staticRenderFns } from "./SalonsNumbers.vue?vue&type=template&id=590ae05c&scoped=true"
import script from "./SalonsNumbers.vue?vue&type=script&lang=js"
export * from "./SalonsNumbers.vue?vue&type=script&lang=js"
import style0 from "./SalonsNumbers.vue?vue&type=style&index=0&id=590ae05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590ae05c",
  null
  
)

export default component.exports